import { render, staticRenderFns } from "./EmployeeSocialInsurance.vue?vue&type=template&id=4d457f95&scoped=true&"
import script from "./EmployeeSocialInsurance.vue?vue&type=script&lang=js&"
export * from "./EmployeeSocialInsurance.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSocialInsurance.vue?vue&type=style&index=0&id=4d457f95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d457f95",
  null
  
)

component.options.__file = "EmployeeSocialInsurance.vue"
export default component.exports